<template>
  <div class="teacher-container">
    <div class="item-background"></div>
    <div class="item-container">
      <div class="left">
        <img
          class="teacher-img"
          src="https://kglab-1258976754.cos.ap-shanghai.myqcloud.com/xxl.jpg"
          alt=""
        />
        <div class="bold-desc">Professor</div>
        <div class="email-desc">xxl@hdu.edu.cn</div>
      </div>
      <div class="right">
        <div class="bold-title">个人介绍 INTRODUCTION</div>

        <div class="right-content">
          <p class="para">
            <strong>徐小良</strong
            >，男，浙江东阳人，博士，教授，博士生导师，杭州电子科技大学计算机软件所副所长，知识图谱与类脑智能实验室主任，杭电-三汇知识图谱联合实验室主任，之江实验室“未来实验室”项目负责人，浙江省人工智能学会理事。2004年毕业于浙江大学，获工学博士学位；2004年至今在杭州电子科技大学任教，其中2007.9-2008.7浙江大学访问学者，2016.8-2016.8新加坡国立大学访问学者；2005年晋升为副教授，2010年晋升为教授。
          </p>
          <p class="para">
            主要研究领域为<strong>大数据知识图谱、自然语言处理、语义搜索、类脑计算</strong>等，曾主持和参与多项国家自然科学基金、国家社科基金、武器装备预研项目、省重点研发项目，在国内外期刊及国际学术会议上发表论文50余篇，申请发明专利40余件，获浙江省科技进步奖三等奖1项。实验室与之江实验室、阿里巴巴、华为、杭州三汇数字信息技术有限公司等单位建立了紧密产学研合作关系。
          </p>
        </div>
        <div class="bold-title">发表论文（近3年） SELECTED PUBLICATIONS</div>
        <div class="right-content">

          ◎ Qiang Yue, Xiaoliang Xu*, Yuxiang Wang, et al., Routing-Guided Learned Product Quantization for Graph-Based Approximate Nearest 
          Neighbor Search, International Conference on Data Engineering (ICDE, CCF A), 2024 <br />

          ◎ Mengzhao Wang, Weizhi Xu, …, Xiaoliang Xu*, et al., Starling: An I/O-Efficient Disk-Resident Graph Index Framework for 
          High-Dimensional Vector Similarity Search on Data Segment, ACM SIGMOD International Conference on Management of Data 
          (SIGMOD, CCF A), 2024<br />

          ◎ Mengzhao Wang, Xiangyu Ke, Xiaoliang Xu, et al., MUST: An Effective and Scalable Framework for Multimodal Search with 
          Target Modality International Conference on Data Engineering (ICDE, CCF A), 2024.<br />

          ◎ Mengzhao Wang, Lingwei Lv, Xiaoliang Xu*, Yuxiang Wang, Qiang Yue, Jiongkang Ni, An Efficient and Robust Framework 
          for Approximate Nearest Neighbor Search with Attribute Constraint, Conference on Neural Information Processing Systems 
          (NeurIPS, CCF A), 2023<br />
          
          ◎ Shuzhan Ye, Xiaoliang Xu, Yuxiang Wang*, Tao Fu, Efficient Complex Aggregate Queries with Accuracy Guarantee based on 
          Execution Cost Model over Knowledge Graphs, Mathematics, 2023, 11(18), 3908; DOI: 10.3390/math11183908 <br />

          ◎ Xiaoxun Gou, Xiaoliang Xu, Xiangying Wu, Runhuai Chen, Yuxiang Wang*, Tianxing Wu, Xiangyu Ke ,Effective and Efficient 
          Community Search with Graph Embeddings，ECAI 2023, Volume 372, p891-898. <br />
          
          ◎ Yuxiang Wang, Jun Liu, Xiaoliang Xu*, Efficient and Effective Academic Expert Finding on Heterogeneous Graphs through 
          (k,P)-Core based Embedding[J], ACM Transactions on Knowledge Discovery from Data,2023,17(6): 85:1-85:35. <br />


          ◎ Yuxiang Wang, Arijit Khan, Xiaoliang Xu, Jiahui Jin, Qifan Hong, Tao
          Fu. Aggregate Queries on Knowledge Graphs: Fast Approximation with
          Semantic-aware Sampling. ICDE 2022. (CCF A)

          <br />◎ Xiaoliang Xu, Jun Liu, Yuxiang Wang*, Xiangyu Ke. Academic
          Expert Finding via (K,P)-Core based Embedding over Heterogeneous
          Graphs. ICDE 2022. (CCF A)

          <br />◎ Yuxiang Wang, Jun Liu, Xiaoliang Xu, Xiangyu Ke, Tianxing Wu, Xiaoxuan Gou. 
          Efficient and Effective Academic Expert Finding on Heterogeneous Graphs through (k,P)-Core based Embedding. 
          Transactions on Knowledge Discovery from Data (TKDD), 2022, Accepted. (CCF B, IF=4.157)

          <br />◎ Xiaoliang Xu, Qifan Hong, Yuxiang Wang*, Jiahui Jin, Xinle Xuan, Tao Fu. 
          A Random Walk Sampling on Knowledge Graphs for Semantic-oriented Statistical Tasks. Data & Knowledge Engineering, 2022. (CCF B)

          <br />◎ Mengzhao Wang, Xiaoliang Xu, Qiang Yue, Yuxiang Wang*. A
          Comprehensive Survey and Experimental Comparison of Graph-Based
          Approximate Nearest Neighbor Search. VLDB 2021. (CCF A)

          <br />◎ Xiaoliang Xu, Mengzhao Wang, Yuxiang Wang, Dingcheng Ma.
          Two-Stage Routing with Optimized Guided Search and Greedy Algorithm on
          Proximity Graph. Knowledge-based Systems (KBS), 2021. (CCF B, JCR R1)

          <br />◎ Yuxiang Wang, Xiaoliang Xu*, Qifan Hong, et al. Top-k Star
          Queries on Knowledge Graphs Through Semantic-aware Bounding Match
          Scores, Knowledge-Based Systems (KBS), 2021, Volume 213(2):106655.
          (CCF B, JCR R1)

          <br />◎ Xiaoliang Xu, Xin Jin*, Rui Yan, et al. Visual pattern
          recognition using enhanced visual features and PSD-based learning
          rule. IEEE Transactions on Cognitive and Developmental Systems (TCDS),
          2017, 10(2): 205-212.

          <br />◎ Xiaoliang Xu, Tong Gao, Yuxiang Wang*, et al. Event Temporal
          Relation Extraction with Attention Mechanism and Graph Neural Network.
          Tsinghua Science and Technology, 2022,27(01):79-90.

          <br />◎ Xiaoliang Xu, Chang Li, Yuxiang Wang*, et al. Multiattribute
          Approximate Nearest Neighbor Search Based on Navigable Small World
          Graph. Concurrency and Computation:Practice and Experience (CCPE),
          2020, 32(24).

          <br />◎ Yuxiang Wang, Zhangpeng Ge, Haijiang Yan, Xiaoliang Xu*, et
          al. Semantic Locality based Approximate Knowledge Graph Query.
          Concurrency and Computation:Practice and Experience (CCPE), 2019,
          31(24):1-13.

          <br />◎ Yuxiang Wang, Jiahui Jin, Xiaoliang Xu*, et al. Skew-aware
          online aggregation over joins through guided sampling. Concurrency and
          Computation: Practice and Experience (CCPE), 2018, 30(20):
          e4695.1-e4695.17.

          <br />◎ Yuxiang Wang, Yixing Xia, Qiming Fang, Xiaoliang Xu*. AQP++: a
          hybrid approximate query processing framework for generalized
          aggregation queries. Journal of computational science (JOCS), 2018,
          26: 419-431.

          <br />◎ Xiaoliang Xu, Wensi Lu, Qiming Fang*, et al. A Visual
          Recognition Model Based on Hierarchical Feature Extraction and
          Multi-layer SNN. International Conference on Neural Information
          Processing (ICONIP), 2018: 525-534.
        </div>
        <div class="bold-title">科研项目（近5年） PROJECTS</div>
        <div class="right-content">
          ◎
          主持浙江省重点研发计划项目“重大活动公共安全智能防控平台开发及应用示范”（2021C03156，240万元）
          <br />◎
          共同承担浙江省重点研发计划项目“浙江省科技特派员服务云平台建设关键技术研究与示范”（2021C02004，800万元）
          <br />◎ 主持之江实验室项目“未来实验室数字化管理和科研辅助工具平台”，
          （2021-2022年），800万 (在研)； <br />◎
          国家社会科学基金重大项目“基于大数据的科教评价信息云平台构建和智能服务研究”（19ZDA348，60万元)子课题负责人
          <br />◎
          参与国家自然科学基金面上项目“语义驱动的知识图谱近似图查询关键技术研究”（62072149，直接经费56万元）
          <br />◎
          参与浙江省重点研发计划项目“区块链关键技术研究与技术交易应用”（2019C01056，300万元）
          <br />◎ 参与武器装备预先研究项目，负责“面向***趋势预测”（2018-2020年）
          <br />◎
          主持浙江省重点研发计划项目“促进成果转化的科技大数据服务平台开发及应用”（2017C01009，300万元）
          <br />◎
          参与浙江省公共科技条件平台建设项目“科技创新云服务平台”（2014-2016年，330万元）
          <br />◎ 主持产学研合作项目“行业领域知识图谱关键技术研究及应用”
        </div>
        <div class="bold-title">发明专利（部分） Patents</div>
        <div class="right-content">
          一种基于近邻图的多模态搜索方法，申请号：202111212706.0，授权<br />
          一种学术异构网络嵌入的模型训练方法及文本表示方法，申请号：202111186456.8，授权<br />
          一种融合地理知识的混合知识图谱构建方法，申请号：202110445559.5，授权<br />
          一种融合结构化和非结构化数据的混合搜索方法，申请号：202110285108.X，授权<br />
          基于关系图注意力神经网络的事件时序关系识别方法，申请号：202011471742.4，授权<br />
          一种语义敏感的知识图谱随机游走采样方法，申请号：202010185892.2，授权<br />
          一种基于编码可导航伸展图的近邻文档搜索方法，申请号：201910949234.3，授权<br />
          一种基于CBOW模型和依存句法关系的词向量表示方法，申请号：201910279906.4，授权<br />
          一种语义敏感的RDF知识图谱近似查询方法，申请号：201910279900.7，授权<br />
          一种基于分层特征提取与多层脉冲神经网络的图像识别方法，申请号：201810782122.9，授权<br />
          一种面向RDF知识图谱的语义近似查询方法，申请号：201810782472.5，授权<br />
          一种面向多脉冲神经网络监督学习的精确突触调整方法，申请号：201810543847.2，授权<br />
          一种面向技术领域的专业人才搜索方法，申请号：201810544758.X，授权<br />
          一种基于专利的科技人才推荐方法，申请号：201710825493.6，授权<br />
          一种基于文档评分模型和相关度的学术论文搜索排序方法，申请号：201710461109.9，授权<br />
          基于RSS线性相关与二次加权质心算法的WLAN指纹定位方法，申请号：201610393181.8，授权<br />
          一种基于MQTT的云推送方法和系统，申请号：201510405881.X，授权<br />
          一种科技项目相似度计算方法，申请号：201310508199.4<br />
          一种基于关键词的评审专家智能检索与推荐方法，申请号：201310511342.5<br />
          一种面向科技项目的评审专家智能推荐方法，申请号：201310509358.2<br />
          一种科技项目申请书特征词提取方法，申请号：201310151425.8<br />
          大规模网络下具有精度保障的快速社区查询系统及方法，申请号：2023114300890<br />
          一种结合硬盘与内存的近邻图向量检索方法及装置，申请号：202211082182.2<br />
          一种面向近邻图向量检索的向量编码学习方法及装置，申请号：202211050160.8<br />
          一种面向公共安全异构信息网络的犯罪团伙查询方法，申请号：202211010988.0<br />
          一种面向公共安全信息网络的犯罪团伙骨干成员搜索方法，申请号：202211010772.4<br />
          一种基于知识图谱的复杂问题语义理解方法，申请号：202210264731.1<br />
          一种基于卷积脉冲神经网络的预注意力提取方法，申请号：202210111325.1<br />
          一种基于脉冲事件的时间表面特征提取方法，申请号：202210107313.1<br />
          一种面向知识图谱近似聚集查询的执行代价预测方法，申请号：202110367405.9<br />
          一种基于依存语义注意力机制的词对上下位关系训练方法，申请号：202011331498.1<br />
          一种结合VP树和导向近邻图的近似最近邻搜索方法，申请号：202011223218.5<br />
          一种应用于大规模高维数据的两阶段近邻图搜索方法，申请号：202010493762.5<br />
          一种基于可导航小世界图的多属性近似最近邻搜索方法，申请号：202010185898.X<br />
          基于语义注意力的循环神经网络事件时序关系识别方法，申请号：201911335582.8<br />
          一种基于分层可导航小世界图的近似最近邻搜索方法，申请号：201910279860.6<br />
          一种基于Gspan和TextRank的科技领域本体构建方法，申请号：201810998966.7<br />
          一种基于word2vec和TextRank的科技文本关键词提取方法，申请号：201810842132.7<br />
          一种分布式的文本近似最近邻语义搜索计算方法，申请号：201810782233.X<br />
          一种基于科研成果数据的人才能力刻画方法，申请号：201710560900.5<br />
          一种基于生物视觉与精确脉冲驱动神经网络的图像识别方法，申请号：201710036419.6<br />
          基于兴趣变化和信任关系的协同过滤推荐方法，申请号：201610916144.0<br />

        </div>
        <div class="bold-title">获奖 Rewards</div>
        <div class="right-content">浙江省科技进步奖三等奖一项</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    document.documentElement.scrollTop = 0;
  },
};
</script>

<style scoped>
.teacher-container {
  min-height: 100vh;
}
.item-container {
  width: 80%;
  margin: 0 auto;
  display: flex;
  padding-top: 60px;
}
.item-background {
  height: 60px;
}
.left {
  width: 15%;
}
.right {
  width: 85%;
  padding-left: 40px;
}
.teacher-img {
  width: 100%;
}
.bold-desc {
  font-weight: bold;
  font-size: 24px;
  text-align: center;
  margin-top: 20px;
}
.email-desc {
  text-align: center;
  color: #03a9f4;
  font-size: 20px;
}
.bold-title {
  color: #4f81bd;
  font-size: 20px;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 20px;
}
.right-content {
  font-size: 20px;
  line-height: 36px;
}
@media screen and (max-width: 900px) {
  .item-container {
    display: block;
  }
  .left {
    width: 100%;
    text-align: center;
  }
  .right {
    width: 100%;
  }
  .teacher-img {
    width: 50%;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/teacher/xuxiaoliang.vue